// https://github.com/zhangxinxu/Tween

/*
 * t: current time（当前时间）；
 * b: beginning value（初始值）；
 * c: change in value（变化量）；
 * d: duration（持续时间）。
*/
export function sineEaseOut(t, b, c, d) {
  return c * Math.sin(t / d * (Math.PI / 2)) + b;
}
export function linear(t, b, c, d) {
  return c * t / d + b;
}
export function sineEaseIn(t, b, c, d) {
  return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
}
export function easeOutElastic(t, b, c, d) {
  var c4 = 2 * Math.PI / 3;
  var x = t / d;

  if (x === 0) {
    return b;
  }

  if (x === 1) {
    return c + b;
  }

  return c * (Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1) + b;
} // https:// easings.net/zh-cn

function easeInOutCircSubFunc(x) {
  return x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
}

function easeOutBounceSubFunc(x) {
  var n1 = 7.5625;
  var d1 = 2.75;

  if (x < 1 / d1) {
    return n1 * x * x;
  }

  if (x < 2 / d1) {
    var _res = n1 * (x -= 1.5 / d1) * x + 0.75;

    return _res;
  }

  if (x < 2.5 / d1) {
    var _res2 = n1 * (x -= 2.25 / d1) * x + 0.9375;

    return _res2;
  }

  var res = n1 * (x -= 2.625 / d1) * x + 0.984375;
  return res;
}

export function animationGenerator(func) {
  return function (t, b, c, d) {
    var strategy = func(t / d);
    return c * strategy + b;
  };
}
export var easeInOutCirc = animationGenerator(easeInOutCircSubFunc);
export var easeOutBounce = animationGenerator(easeOutBounceSubFunc);
export var transitionFunctionMap = {
  linear: linear,
  sineEaseIn: sineEaseIn,
  sineEaseOut: sineEaseOut,
  ease: sineEaseIn,
  easeOutElastic: easeOutElastic,
  easeInOutCirc: easeInOutCirc,
  easeOutBounce: easeOutBounce
};